import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

export const oneTime = [
  {
    title: 'Purchase Price',
    key: 'PurchasePrice',
    template: value => `${formatAsCurrency(value)}`,
  },
  {
    title: 'Goal Year',
    key: 'GoalYear',
    template: ({ AtRetirement, Year }) => {
      if (AtRetirement) {
        return 'At retirement';
      }
      return Year;
    },
  },
  {
    title: 'Additional Savings Per Month',
    key: 'AdditionalSavingsPerMonth',
    template: value => `${formatAsCurrency(value)}`,
  },
  {
    title: 'Asset Allocation Name',
    key: 'AssetAllocationName',
    template: value => value,
  },
  {
    title: 'Rate of Return',
    key: 'RateOfReturn',
    template: value => `${Math.round((value * 100) * 100) / 100}%`,
  },
  {
    title: 'Earmarked Assets',
    key: 'EarmarkedAssets',
    template: value => `Total Earmarked toward this goal ${formatAsCurrency(value)}`,
  },
];

export const recurring = [
  {
    title: 'Purchase Price',
    key: 'PurchasePrice',
    template: value => `${formatAsCurrency(value)} Per Year`,
  },
  {
    title: 'Goal Year',
    key: 'GoalYear',
    template: ({ AtRetirement, Year }) => {
      if (AtRetirement) {
        return 'At retirement';
      }
      return Year;
    },
  },
  {
    title: 'Frequency',
    key: 'Frequency',
    template: frequency => `Every ${frequency.RepeatEveryNYears} Year(s) for ${frequency.RepeatForNYears} Year(s)`,
  },
  {
    title: 'Inflation',
    key: 'Inflation',
    template: value => `${Math.round((value * 100) * 100) / 100}%`,
  },
  {
    title: 'Additional Savings Per Month',
    key: 'AdditionalSavingsPerMonth',
    template: value => `${formatAsCurrency(value)}`,
  },
  {
    title: 'Asset Allocation Name',
    key: 'AssetAllocationName',
    template: value => value,
  },
  {
    title: 'Rate of Return',
    key: 'RateOfReturn',
    template: value => `${Math.round((value * 100) * 100) / 100}%`,
  },
  {
    title: 'Earmarked Assets',
    key: 'EarmarkedAssets',
    template: value => `Total Earmarked toward this goal ${formatAsCurrency(value)}`,
  },
];
